<template>
  <div>
    <v-menu
      v-model="menu2"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="dateFormatted"
          :label="label"
          persistent-hint
          prepend-icon="mdi-calendar"
          v-on="on"
          :class="classPadding"
          @blur="changeInput"
          :dense="dense"
          :readonly="readonly"
          clearable
          v-mask="'##/##/####'"
        >
          <template slot="append">
            <span class="required" v-if="required">*</span>
          </template>
        </v-text-field>
      </template>
      <v-date-picker v-model="date" no-title @input="changeDate" :readonly="readonly"></v-date-picker>
    </v-menu>
    <!-- <p>
      Date in ISO format:
      <strong>{{ date }}</strong>
    </p>-->
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
export default {
  props: {
    label: {
      default: "Date",
      type: String
    },
    classPadding: {
      default: null,
      type: String
    },
    value: {
      default: null,
      type: String
    },
    required: {
      default: false,
      type: Boolean
    },
    dense: {
      default: false,
      type: Boolean
    },
    readonly: {
      default: false,
      type: Boolean
    }
  },
  directives: {
    mask
  },
  data: () => ({
    // date: new Date().toISOString().substr(0, 10),
    // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    date: null,
    dateFormatted: null,
    menu1: false,
    menu2: false
  }),

  computed: {
    computedDateFormatted() {
      if (this.date == "1970-1-1") {
        return "";
      } else return this.formatDate(this.date);
    }
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    value(val) {
      if (val != null) {
        let dateModel = new Date(val);
        let year = dateModel.getFullYear().toString();
        let month = dateModel.getMonth();
        let day = dateModel.getDate();

        this.setItem(
          new Date(year, month, day + 1, 1, 1).toISOString().substr(0, 10)
        );
      } else {
        this.setItem(null);
      }
    }
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    changeDate() {
      this.menu2 = false;
      this.$emit("input", new Date(this.date).toISOString());
    },
    setItem(value) {
      this.date = value;
    },
    changeInput($event) {
      if ($event.target.value) {
        let dateModel = new Date($event.target.value);
        let year = dateModel.getFullYear().toString();
        let month = dateModel.getMonth();
        let day = dateModel.getDate();

        this.date = new Date(year, month, day + 1, 1, 1)
          .toISOString()
          .substr(0, 10);
        this.$emit("input", new Date(this.date).toISOString());
      } else {
        this.$emit("input", null);
      }
    }
  },
  mounted() {
    if (this.value != null) {
      let dateModel = new Date(this.value);
      // let year = dateModel.getFullYear().toString();
      // let month = dateModel.getMonth() + 1;
      // let day = dateModel.getDate();
      let year = dateModel.getFullYear().toString();
      let month = dateModel.getMonth();
      let day = dateModel.getDate();
      this.setItem(
        new Date(year, month, day + 1, 1, 1).toISOString().substr(0, 10)
      );

      // this.setItem(
      //   new Date(`${year}-${month}-${day}`).toISOString().substr(0, 10)
      // );
    } else {
      this.setItem(null);
    }
  }
};
</script>
